import * as React from "react";
import { SaveButton, Toolbar } from "react-admin";

const InactiveDeleteOptionEditToolbar = ({ disabledSaveButton, alwaysEnable, ...props }) => {
  return (
    <Toolbar {...props}>
      <SaveButton
        disabled={disabledSaveButton}
        alwaysEnable={alwaysEnable}
      />
    </Toolbar>
  );
};

export default InactiveDeleteOptionEditToolbar;
